/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState, useContext } from 'react';
import Sladio from '../utils/Sladio/Sladio';
import { sladioConfig } from '../utils/Sladio/SladioConfig';
import Translate from '../i18n/Translate';

import { I18nContext } from '../contexts/I18nProvider';

import Sliders from '../components/Slider';
import Promotions from '../components/Promotions';
import Featured from '../components/Featured';
import ErrorBoundary from '../components/ErrorBoundary';

import PreLoginImage from '../assets/images/static/PreLogin.jpg';
import PartnerLogo1 from '../assets/images/static/PartnerLogo1.png';
import PartnerLogo2 from '../assets/images/static/PartnerLogo2.png';
import PartnerLogo3 from '../assets/images/static/PartnerLogo3.png';
import PartnerLogo4 from '../assets/images/static/PartnerLogo4.png';
import PartnerLogo5 from '../assets/images/static/PartnerLogo5.png';
import PartnerLogo6 from '../assets/images/static/PartnerLogo6.png';
import { AuthContext } from '../contexts/AuthProvider';
import PrivateLink from '../components/PrivateLink';

const Home = ({ isMenuOpen, setIsMenuOpen }) => {
  const { user } = useContext(AuthContext);

  const [loadingSlide1, setLoadingSlide1] = useState(true);
  const [loadingSlide2, setLoadingSlide2] = useState(true);

  const { setActualComponent } = useContext(I18nContext);

  const cred = 'pepe';
  const reservas = process.env.REACT_APP_RESERVAS_URL_NEMO;
  const reservasUrl = process.env.REACT_APP_RESERVAS_URL_NEMO;

  useEffect(() => {
    setActualComponent('home');
  }, []);

  useEffect(() => {
    if (!loadingSlide1 && !loadingSlide2) {
      new Sladio(sladioConfig, true);
    }

    return () => {
      new Sladio({}, false);
    };
  }, [loadingSlide1, loadingSlide2]);

  return (
    <>
      {/* Slider */}
      <ErrorBoundary>
        <Sliders setLoadingSlide1={setLoadingSlide1} />
      </ErrorBoundary>

      {/* Slider */}

      {/* Destacados */}
      <ErrorBoundary>
        <Featured setLoadingSlide2={setLoadingSlide2} />
      </ErrorBoundary>
      {/* Destacados */}

      {/* Promociones */}
      <ErrorBoundary>
        <Promotions />
      </ErrorBoundary>
      {/* Promociones */}

      {/* Partners */}
      {/* Promociones */}

      {/* PreLogin */}
      <section className='prelogin'>
        <div className='preLogin__container'>
          <div className='preLogin__content'>
            <div>
              <h3 className='preLogin__title'>
                <Translate langkey='prelogin.title' />
              </h3>

              <p className='preLogin__text'>
                <Translate langkey='prelogin.subtitle' />
              </p>

              <PrivateLink
                href={`${reservasUrl}`}
                target='_blank'
                rel='noreferrer'
                className='callToAction'
                isAuthenticated={user.isAuthenticated}
                onClick={() => {
                  return setIsMenuOpen(!isMenuOpen);
                }}
              >
                <Translate langkey='prelogin.cta' />
              </PrivateLink>
            </div>
          </div>

          <div className='preLogin__image'>
            <img
              loading='auto'
              src={PreLoginImage}
              alt='Pre login image'
              title='Sign In'
            />
          </div>
        </div>
      </section>
      {/* PreLogin */}

      {/* Partners */}
      <section className='partners'>
        <div className='partners__container'>
          <h2>
            <Translate langkey='financing.title' />
          </h2>

          <div className='partners__content'>
            {/* Mastercard */}
            <div className='content__item'>
              <div className='content__item__image'>
                <img
                  loading='auto'
                  src={PartnerLogo6}
                  alt='Mastercard'
                  title='Mastercard'
                />
              </div>
            </div>
            {/* Mastercard */}

            {/* Comafi */}
            <div className='content__item'>
              <div className='content__item__image'>
                <img loading='auto' src={PartnerLogo5} alt='Comafi' title='Comafi' />
              </div>
            </div>
            {/* Comafi */}

            {/* Visa */}
            <div className='content__item'>
              <div className='content__item__image'>
                <img loading='auto' src={PartnerLogo4} alt='Visa' title='Visa' />
              </div>
            </div>
            {/* Visa */}

            {/* Galicia */}
            <div className='content__item'>
              <div className='content__item__image'>
                <img loading='auto' src={PartnerLogo1} alt='Galicia' title='Galicia' />
              </div>
            </div>
            {/* Galicia */}

            {/* Ahora 12 */}
            <div className='content__item'>
              <div className='content__item__image'>
                <img loading='auto' src={PartnerLogo2} alt='Ahora 12' title='Ahora 12' />
              </div>
            </div>
            {/* Ahora 12  */}

            {/* Macro */}
            <div className='content__item'>
              <div className='content__item__image'>
                <img loading='auto' src={PartnerLogo3} alt='Macro' title='Macro' />
              </div>
            </div>
            {/* Macro */}
          </div>
        </div>
      </section>
      {/* Partners */}
    </>
  );
};

export default Home;
